import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "payment-result-area" }
const _hoisted_2 = { class: "payment-result-card" }
const _hoisted_3 = {
  key: 0,
  class: "result-meta"
}
const _hoisted_4 = { class: "result-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "result-icon success" }, [
        _createElementVNode("i", { class: "ti ti-circle-check" })
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Payment Successful!", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", null, "Your subscription has been activated. You'll receive your access details shortly — check your dashboard for details.", -1)),
      (_ctx.invoiceId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode(" Invoice: ")),
            _createElementVNode("span", null, _toDisplayString(_ctx.invoiceId), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          to: "/dashboard",
          class: "btn"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "border-style" }, "Go to Dashboard", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "result-secondary-link"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Back to Home")
          ])),
          _: 1
        })
      ])
    ])
  ]))
}